export const Divider = {
  baseStyle: {
    opacity: 1,
    borderColor: "whiteAlpha.100",
  },
};
